const inject = [
  '$scope',
  'ogsdk.addressService',
  'requiredFields',
  'ogsdk.Address',
  'editShippingModal',
  'toastService',
  'config'
];

function AddShippingControllerFactory(
  $scope,
  addressService,
  requiredFields,
  Address,
  editShippingModal,
  toastService,
  msiConfig
) {
  class AddShippingController {
    constructor(_requiredFields) {
      this.requiredFields = _requiredFields;
      this.submitting = false;
    }

    $onInit() {
      this.useForAll = true;

      this.model = new Address({
        addressType: 'shipping_address',
        customerId: msiConfig.auth.sig_field
      });
    }

    submit(address = {}, useForAll = false) {
      this.submitting = true;

      return addressService.create(address)
        .then(createdAddress => editShippingModal.submit(createdAddress.publicId, useForAll))
        .then($scope.$close)
        .then(() => toastService.translate.success('TOAST_CHANGE_SHIPPING_SUCCESS'))
        .catch(() => toastService.translate.danger('TOAST_CHANGE_SHIPPING_DANGER'))
        .finally(() => {
          this.submitting = false;
        });
    }
  }

  return new AddShippingController(requiredFields);
}

AddShippingControllerFactory.$inject = inject;

angular.module('msi.shipping.add')
  .controller('AddShippingController', AddShippingControllerFactory);

module.exports = AddShippingControllerFactory;
